import history from 'history/browser'
import React, { Component } from 'react'
import CurrencyFormat from 'react-currency-format'
import { connect } from 'react-redux'
import store from '../../engine/store'
import { Bloc, BlocIntField, BlocTextField, Title } from '../ImportAll'
import './Bloc.css'

class BlocRenegoEdition extends Component {
    constructor(props) {
        super(props)

        if (this.props.listPaliers) {
            this.state = { listPaliers: this.props.listPaliers }
        } else {
            this.state = {
                listPaliers: [
                    {
                        mensualite: 0,
                        duree: 0,
                    },
                ],
            }
        }
    }

    ajouterPalier() {
        var newPalier = this.state.listPaliers
        newPalier.push({
            mensualite: 0,
            duree: 0,
        })
        this.setState({
            listPaliers: newPalier,
        })
    }

    supprimerPalier(index) {
        var newPalier = this.state.listPaliers
        newPalier.splice(index, 1)
        this.setState({
            listPaliers: newPalier,
        })
    }

    updateValueMensualiter(index, value) {
        var newValue = value.floatValue ? value.floatValue : 0
        var newPalier = this.state.listPaliers
        newPalier[index]['mensualite'] = newValue
        this.setState({
            listPaliers: newPalier,
        })
    }
    updateValueDuree(index, value) {
        var newValue = value.floatValue ? value.floatValue : 0
        if (newValue > 420) newValue = 420
        var newPalier = this.state.listPaliers
        newPalier[index]['duree'] = newValue
        this.setState({
            listPaliers: newPalier,
        })
    }

    validerPret() {
        store.dispatch({
            type: 'SET',
            value: {
                key: 'credit_renego_paliers_' + this.props.creditID,
                value: this.state.listPaliers,
            },
        })
        if (this.props.isNewPret) {
            store.dispatch({
                type: 'SET_MULTI',
                value: {
                    key: 'credit_renego_list',
                    value: this.props.creditID,
                },
            })
        }
        history.push('/tunnelmobile/', { targetView: 25 })
    }

    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        style.minHeight = '122px'

        const content = this.state.listPaliers.map((palier, index) => (
            <div className={className} style={style} key={index}>
                <div className="infoBulleContainer">
                    <img
                        src="svg/delete.svg"
                        alt="remove"
                        onClick={() => this.supprimerPalier(index)}
                    ></img>
                </div>

                <div className="size18 bold-font">Palier {index + 1}</div>

                <div className="labelfield">
                    Mensualité (assurance comprise)
                </div>

                <CurrencyFormat
                    value={this.state.listPaliers[index]['mensualite']}
                    placeholder="Ex : 500 € / mois"
                    className="field bold-font"
                    thousandSeparator={' '}
                    decimalSeparator={','}
                    allowNegative={false}
                    format={'##### €/mois'}
                    type="tel"
                    suffix=" €/mois"
                    onValueChange={(value) =>
                        this.updateValueMensualiter(index, value)
                    }
                />
                <div className="labelfield">Durée restante (en mois)</div>

                <CurrencyFormat
                    value={this.state.listPaliers[index]['duree']}
                    placeholder="Ex : 60 mois"
                    className="field bold-font"
                    thousandSeparator={' '}
                    decimalSeparator={','}
                    type="tel"
                    format={'### mois'}
                    suffix=" mois"
                    onValueChange={(value) =>
                        this.updateValueDuree(index, value)
                    }
                />
            </div>
        ))
        //

        // TODO grisé et rendre inactif le button si pas bien rempli
        const styleButton = {}
        const disabledButton = false

        return (
            <div>
                <div className="Container">
                    <Bloc
                        key="key45"
                        selectable
                        linked_data_id={this.props.nameType}
                        linked_data_value="pret_bancaire"
                        nbcolumn={2}
                        gauche
                        simpleWord
                        text1="Prêt bancaire"
                    />
                    <Bloc
                        key="key46"
                        selectable
                        linked_data_id={this.props.nameType}
                        linked_data_value="ptz"
                        nbcolumn={2}
                        droit
                        simpleWord
                        text1="Prêt a Taux Zéro"
                    />
                    <BlocIntField
                        linked_data_id={this.props.nameCapital}
                        symbole=" €"
                        label="Capital restant dû"
                        placeholder="Ex : 35 000 €"
                    />
                    <BlocTextField
                        linked_data_id={this.props.namePreteur}
                        label="Organisme prêteur"
                        placeholder="Ex : Crédit Agricole"
                    />
                    <Title maintitle="Paliers de mensualités" />
                    {content}
                </div>
                <div className="Container">
                    <div
                        className="renegoNewPalierButton"
                        onClick={() => this.ajouterPalier()}
                    >
                        {' '}
                        Ajouter un palier
                    </div>
                </div>
                <div className="Container">
                    <div
                        className="renegoValiderPretButton"
                        disabled={disabledButton}
                        style={styleButton}
                        onClick={() => this.validerPret()}
                    >
                        {' '}
                        Valider le prêt
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    var creditID = state.answer['tech_credit_renego_target']
    return {
        isNewPret: state.answer['tech_credit_renego_target_new'],
        creditID: creditID,
        nameType: 'credit_renego_type_' + creditID,
        nameCapital: 'credit_renego_capital_' + creditID,
        nameDuree: 'credit_renego_duree_' + creditID,
        namePreteur: 'credit_renego_preteur_' + creditID,
        listPaliers: state.answer['credit_renego_paliers_' + creditID],
    }
}

export default connect(mapStateToProps)(BlocRenegoEdition)
